import { useQuery } from '@apollo/client';
import { Box, Card, CardContent, CardHeader, Stack } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import User from '../auth/models/User';
import { ClinicProvider } from '../clinics/context/ClinicContext';
import PageContent from '../common/MainLayout/Page';
import UsersTable from './table/UsersTable';
import clientGraphql from '../../common/apollo-graphql';
import { GET_USERS } from '../user/gql/Query';
import { IconUsers } from '@tabler/icons';
import { gridSpacing } from '../../common/themes/constants';

function ViewUserDetails({ userData, loading, handleFilterChanged }) {
  return (
    <Stack direction="column"
      spacing={1}>
      <Card>
        <CardHeader
          avatar={<IconUsers />}
          title="Users"
        />
        <CardContent>
          <Box sx={{ m: -3 }}
            direction="column"
            spacing={gridSpacing}>

            <UsersTable data={userData}
              loading={loading}
              showToolbar={true}
              useGraphqlDelete={true}
              handleFilterChanged={handleFilterChanged} />
          </Box>
        </CardContent>
      </Card>
    </Stack>
  );
};

export default function ManageUsers({ history }) {
  const { id } = 1;
  const [userData, setUserData] = useState({ rows: [], count: 0 });
  const [keyword, setKeyword] = useState('');
  const { loading, data, refetch } = useQuery(GET_USERS, {
    client: clientGraphql,
    variables: {
      keyword,
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  useEffect(() => {
    if (data) {
      setUserData({
        rows: data.rows.map(item => {
          return {
            ...item,
            userObj: new User({ ...item }),
          };
        }),
        count: data.rows.length,
      });
    }
  }, [data]);

  const handleFilterChanged = useCallback((e) => {
    setKeyword(e.target.value);
  }, []);

  return (
    <PageContent contentClass="manage-users">
      <ClinicProvider
        value={{
          id,
          refetch
        }}>
        {
          <ViewUserDetails loading={loading}
            userData={userData}
            handleFilterChanged={handleFilterChanged} />
        }
      </ClinicProvider>

    </PageContent>
  );
};
